import { Blockquote, Amazon, Series, InternalLink } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Blockquote,
  Amazon,
  Series,
  InternalLink,
  React
};